<template lang="pug">
v-list(class='object-meta' dense)
  v-list-tile
    v-list-tile-content(class='grey--text') Подъездов
    v-list-tile-content(class='align-end') {{ object.sections }}
  v-list-tile
    v-list-tile-content(class='grey--text') Этажность
    v-list-tile-content(class='align-end') {{ object.floor_counts }}
  v-list-tile(v-if='object.price.min>0')
    v-list-tile-content(class='grey--text') Стоимость от
    v-list-tile-content(class='align-end') {{ object.price.min | currency('', 0,{ thousandsSeparator: ' ' }) }} руб.
  v-list-tile(v-else='object.price.min>0')
    v-list-tile-content(class='accent--text') Стоимость от
    v-list-tile-content(class='align-end') НЕТ ЦЕН
  v-list-tile
    v-list-tile-content(class='grey--text') Площади, м.кв.
    v-list-tile-content(class='align-end') {{ object.square.min }} &mdash; {{ object.square.max }}
  v-list-tile
    v-list-tile-content(class='grey--text') В продаже
    v-list-tile-content(class='align-end') {{ object.placements_sale }}
  v-list-tile
    v-list-tile-content(class='grey--text') Срок сдачи объекта
    v-list-tile-content(class='align-end') {{ date | date }}
</template>

<script>
export default {
  props: ['date', 'object']
}
</script>

<style scoped>
.object-meta >>> .v-list__tile {
  height: 32px;
}
.grey--text {
  line-height: 11px !important;
}
</style>
